import { Box, Flex, Heading } from "@sidelinesports/fan-design-system";
import { SlideoutPanel } from "../../../../components/index.tsx";
import styles from "./LiveFeedPanelHeader.module.css";

export const LiveFeedPanelHeader = () => {
  return (
    <Flex
      // The header needs a background color to cover content scrolling underneath
      as={Box}
      bg="primary"
      className={styles.header}
      gap={24}
      align="center"
      justify="start"
      p={16}
    >
      <SlideoutPanel.BackButton />
      <Heading level={1}>Live Feed</Heading>
    </Flex>
  );
};
